import isEmpty from "lodash/isEmpty";
import { OrderedRecord } from "../types/redux-store";

export const normalizeEntity = <T extends { _id: string }>(
  items: T[],
  key: "_id" = "_id"
): OrderedRecord<T> => {
  const byId: Record<string, T> = {};
  const allIds: string[] = [];

  if (isEmpty(items)) {
    return {
      byId,
      allIds,
    };
  }

  items.map((item) => {
    if (!item[key]) {
      throw new Error(`Unable to normalize entity without ${key}`);
    }
    byId[item[key]] = item;
    allIds.push(item[key]);
  });

  return {
    byId,
    allIds,
  };
};

export const immutableUpdate = <T>(
  list: T[],
  index: number,
  obj?: Partial<T>
) => {
  if (obj) {
    return [
      ...list.slice(0, index),
      {
        ...list[index],
        ...obj,
      },
      ...list.slice(index + 1),
    ];
  }
  return [...list.slice(0, index), ...list.slice(index + 1)];
};

export const immutableAdd = <T>(list: T[], index: number, obj: T) => {
  if (list[index] === undefined) {
    // eslint-disable-next-line unicorn/no-useless-spread
    const newArr = [...list.slice(0)];

    newArr[index] = obj;
    return newArr;
  }

  return [
    ...list.slice(0, index),
    {
      ...obj,
    },
    ...list.slice(index),
  ];
};
